<template>
  <div class="border-b flex items-center py-2 overflow-x-hidden hover:bg-slate-50" v-bind="$attrs">
    <div class="grow flex">
      <div class="w-12 text-center cursor-pointer" @click="emitFold">
        <i class="fa-solid fa-angle-down"></i>
      </div>
      [{{ item.menuPosition }}]
      <div class="w-12 text-center">
        <i :class="item.icon" class="mx-2 w-8" v-if="item.icon" />
      </div>
      {{ item.name }}
    </div>
    <div class="w-3/12">
      {{ item.screenRoute }}
    </div>

    <div class="w-1/12 text-center" >
      <i class="fa-solid fa-pen mx-2 cursor-pointer" @click="edit(item.id)"  v-can="'screen.edit'" />
      <i class="fa-solid fa-trash mx-2 cursor-pointer" @click="removeConfirm(item)" v-can="'screen.delete'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    zoom: Boolean,
    modelValue: Boolean,
  },
  data: () => ({
    fold: false,
  }),
  methods: {
    edit(obj) {
      this.$emit('edit', obj)
    },
    removeConfirm(obj) {
      this.$emit('removeConfirm', obj)
    },
    emitSelectedItem(obj) {
      this.$emit('emitSelectedItem', obj)
    },
    emitFold() {
      this.fold = !this.fold
      this.$emit('update:modelValue', this.fold)
    },
  },
}
</script>

<style></style>
